import { gql } from '@apollo/client';

// ============================================================================
// Shared Fragments — reused across multiple operations
// ============================================================================

export const PAGE_INFO_FIELDS = gql`
  fragment PageInfoFields on PageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
`;

export const DOCUMENT_LINE_FIELDS = gql`
  fragment DocumentLineFields on DocumentLine {
    lineNumber
    lineType
    articleNumber
    description
    description2
    quantity
    packageQuantity
    quantityPerPackage
    piecesPerPackage
    unit
    unitPrice
    netUnitPrice
    discount
    amount
    isReturn
    priceFactor
    deliveryNumber
    orderNumber
    manufacturer
  }
`;

/**
 * Summary fields for document list views (without lines).
 */
export const DOCUMENT_SUMMARY_FIELDS = gql`
  fragment DocumentSummaryFields on Document {
    id
    type
    documentNumber
    customerNumber
    customerName
    yourReference
    commission
    documentDate
    locationCode
    shipmentWeek
    pdfKey
    netTotal
    grossTotal
    lineCount
    isRead
    isOrdered
    orderedAt
  }
`;

/**
 * Full document fields including lines — for detail views.
 */
export const DOCUMENT_DETAIL_FIELDS = gql`
  fragment DocumentDetailFields on Document {
    id
    type
    documentNumber
    customerNumber
    customerName
    customerName2
    contact
    yourReference
    commission
    orderDate
    deliveryDate
    documentDate
    locationCode
    shipmentWeek
    systemId
    pdfKey
    netTotal
    grossTotal
    processedAt
    lineCount
    netUnitPriceStatus
    isRead
    isOrdered
    orderedAt
    lines {
      ...DocumentLineFields
    }
  }
  ${DOCUMENT_LINE_FIELDS}
`;

export const FAVORITE_ITEM_FIELDS = gql`
  fragment FavoriteItemFields on FavoriteItem {
    articleNumber
    description
    description2
    quantity
    unit
    unitPrice
    amount
    labels
    pinned
    imageUrl
    addedAt
    lastNetUnitPrice
    lastPurchaseDate
    lastDocumentNumber
    lastDocumentType
  }
`;

export const MATERIAL_TEMPLATE_FIELDS = gql`
  fragment MaterialTemplateFields on MaterialTemplate {
    id
    name
    itemCount
    lastUsed
    labels
    accentColor
    items {
      articleNumber
      quantity
      description
      description2
      unit
      quantityPerPackage
      piecesPerPackage
      note
    }
  }
`;

export const MATERIAL_REQUEST_FIELDS = gql`
  fragment MaterialRequestFields on MaterialRequest {
    id
    name
    status
    createdAt
    updatedAt
    commission
    desiredDeliveryDate
    desiredDeliveryWeek
    note
    navDocumentNo
    navImportedAt
    items {
      id
      articleNumber
      description
      description2
      quantity
      unit
      unitPrice
      amount
      note
      imageUrl
      quantityPerPackage
      piecesPerPackage
      priceFactor
    }
    netTotal
  }
`;

export const ARTICLE_FIELDS = gql`
  fragment ArticleFields on Article {
    articleNumber
    name
    description2
    unit
    basePrice
    imageUrl
    ean
  }
`;

export const CUSTOMER_ARTICLE_FIELDS = gql`
  fragment CustomerArticleFields on CustomerArticle {
    articleNumber
    description
    description2
    unit
    imageUrl
    lastNetUnitPrice
    lastPurchaseDate
    lastDocumentNumber
    lastDocumentType
    totalQuantity
    documentCount
    isFavorite
    manufacturer
  }
`;
